import { useMutation } from '@apollo/client/react';
import { useTranslation } from 'react-i18next';
import { Button } from '@insio/ui-toolkit';
import { useAuth } from '../../context';
import { StopImpersonationDocument } from '@/graphql';
import { useToastHelpers } from '@/hooks/use-toast-helpers';

/** Banner zobrazovaný při aktivní impersonaci. Umožňuje operátorovi relaci ukončit. */
export function ImpersonationBanner() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { showError } = useToastHelpers();

  const [stopImpersonation, { loading }] = useMutation(StopImpersonationDocument, {
    onCompleted: () => {
      window.location.reload();
    },
    onError: () => {
      showError(t('impersonation.banner.stopError'));
    }
  });

  if (!user?.isImpersonating) {
    return null;
  }

  const displayName = [user.firstName, user.lastName].filter(Boolean).join(' ') || user.email || '';

  return (
    <div
      className='flex items-center justify-between bg-warn-bg border-b border-warn-border px-lg py-sm'
      data-testid='impersonation-banner'
      role='alert'
    >
      <span className='text-warn-text text-sm font-medium'>
        {t('impersonation.banner.message', { name: displayName })}
      </span>
      <Button
        variant='default'
        outline='default'
        size='sm'
        onClick={() => stopImpersonation()}
        disabled={loading}
        testId='impersonation-banner-stop-btn'
      >
        {loading ? t('impersonation.banner.stopping') : t('impersonation.banner.stopButton')}
      </Button>
    </div>
  );
}
